<template>
  <Cards>
    <TopSearch ref="topSearchRef" :adminShow="true" :search-show="true" @searchKey="getSearchKey"/>
  </Cards>
  <Cards>
    <div>
      <div>
        <!-- header -->
        <div class="top_tips">
          <h2 style="font-weight: 500;font-size: 18px !important;">{{ $t('common.customer.public') }}</h2>
          <div>
            <el-button
                :disabled="totalsPublic===0"
                type="danger"
                :icon="Delete"
                @click="handleClickDelete"
                v-if="isSuperAdmin"
                size="small"
            >{{ $t('common.delete') }}
            </el-button>
            <el-button
                type="primary"
                :icon="Download"
                @click="handleClickExport"
                size="small"
            >{{ $t("common.claim") }}
            </el-button
            >
            <el-button
                type="primary"
                :icon="DocumentRemove"
                @click="handleClickRecent"
                size="small"
            >{{ $t("common.claim.record") }}
            </el-button
            >
          </div>
        </div>
        <!-- 公海客户表 -->
        <el-table
            v-loading="isLoading"
            :data="customerList"
            ref="targetTable"
            style="width: 100%;margin-top: 16px"
            @selection-change="handleSelectionChange"
            @select="handleCheck"
            @select-all="handleClickSelectAll"
            @row-click="handleClickTargetData"
            :cell-style="rowClassNamePublic"
            :header-cell-style="headerClassNamePublic"
            :row-key="row => row.id"
            @cell-mouse-leave="clearVisiblePopover"
        >
          <el-table-column :reserve-selection="true" type="selection" width="40"/>
          <el-table-column
              v-for="(item, index) in table_columns_public_list"
              :key="item.key"
              :label="item.key"
              :prop="item.value"
              label="Date"
              :width="handleClickSelectWidth(item,1)"
              :min-width="handleClickSelectMinWidth(item,1)"
          >
            <!--            :show-overflow-tooltip="item.value==='customerType'||item.value==='customerName'||item.value==='customerCode'||item.value==='customerOrigin'?true:false"-->
            <template #default="{ row, column, $index }">
              <template v-if="item.value === 'mangerVOList'">
                <div class="hover" v-if="row.mangerVOList.length > 0">
                  <!-- 触发内容1 -->
                  <el-button link type="primary" :ref="ref => (refMap[row.customerCode] = ref)"
                             @mouseover.stop="handleRef(refMap[row.customerCode], row, 2)">
                    {{ row.mangerVOList.length }}
                  </el-button>
                </div>
                <template v-else>
                  <el-button link type="info">
                    {{ row.mangerVOList.length }}
                  </el-button>
                </template>
              </template>
              <template v-else-if="item.value==='customerCode'">
                <div :ref="ref => (refMap[`${row.id}_public_code`] = ref)"
                     @mouseover.stop="handleRef(refMap[`${row.id}_public_code`], row, 7)"
                     v-if=" getTextLength(row.customerCode) > sizeMaxNumber"
                     class="over_normal"
                     :key="row.customerCode">
                  {{
                    getTextLength(row.customerCode) > sizeMaxNumber ? formatText(row.customerCode, sizeMaxNumber) : row.customerCode
                  }}
                </div>
                <div v-else class="over_normal">
                  {{ row.customerCode }}
                </div>
              </template>
              <template v-else-if="item.value ==='zoneAddress'">
                <div style="cursor: pointer;">
                  <!-- 触发内容1 -->
                  <el-image :ref="ref => (refMap[`${row.id}_public_img`] = ref)"
                            @mouseover.stop="handleRef(refMap[`${row.id}_public_img`], row, 3)"
                            v-if="row.zoneAddress"
                            :src="flag[row.zoneCode]"
                            style="width:26px;height:20px;margin-right:2px;vertical-align: middle;" :key="row.zoneCode"
                            lazy
                  />
                </div>
              </template>
              <template v-else-if="item.value === 'maiContactVOList'">
                <div class="hover" v-if="row.maiContactVOList.length > 0">
                  <!-- 触发内容1 -->
                  <el-button link type="primary" :ref="ref => (refMap[row.id] = ref)"
                             @mouseover.stop="handleRef(refMap[row.id], row, 1)">
                    {{ row.maiContactVOList.length }}
                  </el-button>
                </div>
                <div v-else>
                  <el-button link type="info">
                    {{ row.maiContactVOList.length }}
                  </el-button>
                </div>
              </template>
              <template v-else-if="item.value ==='lastTime'">
                <div>{{ row.lastTime }}</div>
              </template>
              <template v-else-if="item.value === 'customerName'">
                <div :ref="ref => (refMap[`${row.id}_public_name`] = ref)"
                     @mouseover.stop="handleRef(refMap[`${row.id}_public_name`], row, 5)"
                     v-if="getTextWidth(row.customerName)>=middleValueWidth"
                     class="over_normal"
                     :key="row.customerName"
                >
                  {{ row.customerName }}
                </div>
                <div v-else class="over_normal">
                  {{ row.customerName }}
                </div>
              </template>
              <template v-else-if="item.value==='customerOrigin'">
                  <div class="over_normal">
                    <el-tag type="info"
                            v-if="getDetailFirstName(row?.mailCustomerOriginDetailVoList)"
                            :ref="ref => (refMap[`${row.id}_source`] = ref)"
                            @mouseover.stop="shouldShowTagNamePopover(row?.mailCustomerOriginDetailVoList) && handleRef(refMap[`${row.id}_source`], row, 6)">
                      {{
                        shouldShowTagNamePopover(row?.mailCustomerOriginDetailVoList)
                            ? formatText(getDetailFirstName(row?.mailCustomerOriginDetailVoList), sizeMaxNumber, true)
                            : getDetailFirstName(row?.mailCustomerOriginDetailVoList)
                      }}
                    </el-tag>
                    <el-button v-if="getDetailExtraCount(row?.mailCustomerOriginDetailVoList) > 0"
                               link
                               type="primary"
                               class="tag-popover-trigger"
                               :ref="ref => (refMap[`${row.id}_source_more`] = ref)"
                               @mouseover.stop="handleRef(refMap[`${row.id}_source_more`], row, 12)">
                      +{{ getDetailExtraCount(row?.mailCustomerOriginDetailVoList) }}
                    </el-button>
                </div>
              </template>
              <template v-else-if="item.value==='customerIntention'">
                  <div class="over_normal">
                    <el-tag type="info"
                            v-if="getDetailFirstName(row?.mailProductDetailVoList)"
                            :ref="ref => (refMap[`${row.id}_product`] = ref)"
                            @mouseover.stop="shouldShowTagNamePopover(row?.mailProductDetailVoList) && handleRef(refMap[`${row.id}_product`], row, 11)">
                      {{
                        shouldShowTagNamePopover(row?.mailProductDetailVoList)
                            ? formatText(getDetailFirstName(row?.mailProductDetailVoList), sizeMaxNumber, true)
                            : getDetailFirstName(row?.mailProductDetailVoList)
                      }}
                    </el-tag>
                    <el-button v-if="getDetailExtraCount(row?.mailProductDetailVoList) > 0"
                               link
                               type="primary"
                               class="tag-popover-trigger"
                               :ref="ref => (refMap[`${row.id}_product_more`] = ref)"
                               @mouseover.stop="handleRef(refMap[`${row.id}_product_more`], row, 13)">
                      +{{ getDetailExtraCount(row?.mailProductDetailVoList) }}
                    </el-button>
                </div>
              </template>
              <template v-else-if="item.value === 'customerType'">
                <div :ref="ref => (refMap[`${row.id}_type`] = ref)"
                     @mouseover.stop="handleRef(refMap[`${row.id}_type`], row, 4)"
                     v-if="getTextLength(row.customerType) > sizeMaxNumber"
                     :key="row.customerType"
                     class="over_normal">
                  {{
                    getTextLength(row.customerType) > sizeMaxNumber ? formatText(row.customerType, sizeMaxNumber) : row.customerType
                  }}
                </div>
                <div v-else class="over_normal">
                  {{ row.customerType }}
                </div>
              </template>
              <template v-else-if="item.value==='createName'">
                <div :ref="ref => (refMap[`${row.id}_create_name`] = ref)"
                     @mouseover.stop="handleRef(refMap[`${row.id}_create_name`], row, 8)"
                     v-if="getTextLength(row.createName) > sizeMaxNumber"
                     class="over_normal"
                     :key="row.createName">
                  {{
                    getTextLength(row.createName) > sizeMaxNumber ? formatText(row.createName, sizeMaxNumber) : row.createName
                  }}
                </div>
                <div v-else class="over_normal">
                  {{ row.createName }}
                </div>
              </template>
            </template>
          </el-table-column>
          <el-table-column :label="$t('common.cz')" :width="140">
            <template #default="{ row, column, $index }">
              <ConfirmDeletePopover
                  :visible="row.popoverVisible"
                  :width="164"
                  :message="$t('common.cds7')"
                  :ref="`popover-${$index}`"
                  @update:visible="(value) => (row.popoverVisible = value)"
                  @confirm:delete="handleDeleteRow(row, column, $index)"
              >
                <template #settings>
                  <el-button
                      link
                      size="small"
                      style="font-size: 13px !important;"
                      type="primary"
                      @click="row.popoverVisible = true"
                  >{{ $t('common.claim') }}
                  </el-button
                  >
                </template>
              </ConfirmDeletePopover>
              <!--删除-->
              <ConfirmDeletePopover
                  :visible="row.popoverVisibleDelete"
                  :width="164"
                  :message="$t('sys.message.ask.delete')"
                  :ref="`popover-${$index}`"
                  @update:visible="(value) => (row.popoverVisibleDelete = value)"
                  @confirm:delete="handleDeleteRowCustomer(row, column, $index)"
              >
                <template #settings>
                  <el-button
                      link
                      size="small"
                      style="font-size: 13px !important;"
                      type="danger"
                      @click.native.stop="row.popoverVisibleDelete = true"
                  >{{ $t('common.delete') }}
                  </el-button
                  >
                </template>
              </ConfirmDeletePopover>
            </template>
          </el-table-column>
          <template #empty>
            <el-empty :description="$t('common.data.empty')" :image="emptyUrl"/>
          </template>
        </el-table>
      </div>
      <!-- 对话框 -->
      <el-dialog
          v-model="dialogVisible"
          width="890"
          :title="i18n.global.t('common.claim.record')"
          class="noheadline"
          top="2em"
      >
        <el-form>
          <el-form-item :label="$t('common.claim.user')+':'"
                        style="width: 200px;font-size: 14px;font-weight: normal!important;">
            <el-select
                @change="clickSelection"
                v-model="selectKeys"
                size="small"
                :placeholder="$t('common.setting.allTime')"
            >
              <el-option
                  v-for="item in tableDataSelect"
                  :label="item.userName"
                  :value="item.userId"
                  :key="item.userId"
              />
            </el-select>
          </el-form-item>
        </el-form>
        <!-- table -->
        <el-scrollbar style="margin-top: -15px">
          <el-table
              v-loading="loading"
              ref="multipleTableRef"
              :data="tableData"
              style="width: 100%; margin-top: 15px"
              :cell-style="rowClassName"
              :header-cell-style="headerClassName"
          >
            <el-table-column
                v-for="item in table_columns_public_2"
                :key="item.value"
                :label="item.key"
                :prop="item.value"
                :width="handleClickSelectWidth(item,2)"
                :min-width="handleClickSelectMinWidth(item,2)"
            >
              <!--              :show-overflow-tooltip="item.value==='customerName'||item.value==='customerCode'||item.value==='userName'?true:false"-->
              <template #default="{ row, column, $index }">
                <template v-if="item.value==='customerCode'">
                  <div :ref="ref => (refMap[`${row.id}_name_code`] = ref)"
                       @mouseover.stop="handleRef(refMap[`${row.id}_name_code`], row, 7)"
                       class="over_normal"
                       v-if="getTextLength(row.customerCode) > sizeMaxNumber"
                       :key="row.customerCode"
                       @click.native.stop="toDetail(row)">
                    {{
                      getTextLength(row.customerCode) > sizeMaxNumber ? formatText(row.customerCode, sizeMaxNumber) : row.customerCode
                    }}
                  </div>
                  <div v-else class="over_normal">
                    {{ row.customerCode }}
                  </div>
                </template>
                <template v-else-if="item.value === 'customerName'">
                  <div :ref="el => setRef(el, row)"
                       class="over_text"
                       :key="row.customerName"
                       @mouseenter="handleMouseEnter(row)"
                       @click.native.stop="toDetail(row)">
                    {{ row.customerName }}
                  </div>
                  <!--          <div class="over_text" @click.native.stop="toDetail(row)">-->
                  <!--            {{ row.customerName }}-->
                  <!--          </div>-->
                </template>
                <template v-else-if="item.value==='auditName'">
                  <div :ref="ref => (refMap[`${row.id}_audit_name`] = ref)"
                       @mouseover.stop="handleRef(refMap[`${row.id}_audit_name`], row, 9)"
                       v-if="getTextLength(row.auditName) > sizeMaxNumber"
                       class="over_normal"
                       :key="row.auditName">
                    {{
                      getTextLength(row.auditName) > sizeMaxNumber ? formatText(row.auditName, sizeMaxNumber) : row.auditName
                    }}
                  </div>
                  <div v-else class="over_normal">
                    {{ row.auditName }}
                  </div>
                </template>
                <template v-else-if="item.value==='userName'">
                  <div :ref="ref => (refMap[`${row.id}_user_name`] = ref)"
                       @mouseover.stop="handleRef(refMap[`${row.id}_user_name`], row, 10)"
                       v-if="getTextLength(row.userName) > sizeMaxNumber"
                       class="over_normal"
                       :key="row.userName">
                    {{
                      getTextLength(row.userName) > sizeMaxNumber ? formatText(row.userName, sizeMaxNumber) : row.userName
                    }}
                  </div>
                  <div v-else class="over_normal">
                    {{ row.userName }}
                  </div>
                </template>
                <template v-if="item.key === $t('common.examine.state')">
                  <template v-if="row.auditStatus === 1">
                    <el-button link size="small">{{ $t('common.examine.wait') }}</el-button>
                  </template>
                  <template v-else-if="row.auditStatus === 2">
                    <el-button link size="small" type="success">{{ $t('common.email.passed') }}</el-button>
                  </template>
                  <template v-else-if="row.auditStatus === 3">
                    <el-button link size="small" type="danger">{{ $t('common.email.rejected') }}</el-button>
                  </template>
                </template>
              </template>
            </el-table-column>
            <template #empty>
              <el-empty :description="$t('common.data.empty')" :image="emptyUrl"/>
            </template>
          </el-table>
          <div class="pages" style="margin-top: 10px">
            <el-pagination
                size="small"
                v-model:current-page="currentDia"
                v-model:page-size="sizeDia"
                background
                :pager-count="4"
                layout="total, prev, pager, next, jumper"
                v-if="totalsDia"
                :total="totalsDia"
                @current-change="handleCurrentChangeDia"
            />
          </div>
        </el-scrollbar>
        <!-- 分页 -->
      </el-dialog>
      <!-- 分页 -->
      <div class="pages">
        <Pagination v-model:modelValue="currentPublic"
                    v-model:pageSizeValue="sizePublic"
                    :total="totalsPublic"
                    v-if="totalsPublic"
                    ref="PageZQ"
                    :selected="selectedCount"
                    @change="handleCurrentChange"
                    @checkAllItemPage="checkAllItemPage"
                    @unCheckAllItemPage="unCheckAllItemPage"
                    @getSelect="getSelectValue"
                    :multipleSelection="multipleSelection"
                    :is-show-select="true"
        ></Pagination>
      </div>
    </div>
  </Cards>

  <!--  el-popover-->
  <el-popover
      :visible="visiblePopover"
      :transition="popoverTransition"
      :virtual-ref="tempRef"
      virtual-triggering
      :popper-style="{ minWidth: '60px', width: 'auto' }"
      trigger="hover"
      effect="dark"
      placement="right"
  >
  <div @mouseenter="keepPopoverVisible" @mouseleave="clearVisiblePopover">
    <template v-if="popoverType === 1">
      <!-- 业务逻辑1 -->
      <div class="popover-content" v-html="
      '<div>' +
      activeItemElpopover.maiContactVOList
        .map(item => `${item.contactName}<br/>`)
        .join('') +
      '</div>'
    "></div>
    </template>
    <template v-else-if="popoverType === 2">
      <!-- 业务逻辑2 -->
      <div class="popover-content" v-html="
      '<div>' +
      activeItemElpopover.mangerVOList
        .map(item => `${item.managerName}<br/>`)
        .join('') +
      '</div>'
    "></div>
    </template>
    <template v-else-if="popoverType === 3">
      <div class="popover-content">{{ activeItemElpopover.zoneAddress }}</div>
    </template>
    <template v-else-if="popoverType === 4">
      <div class="popover-content">{{ activeItemElpopover.customerType }}</div>
    </template>
    <template v-else-if="popoverType === 5">
      <div class="popover-content">{{ activeItemElpopover.customerName }}</div>
    </template>
    <template v-else-if="popoverType === 6">
      <div class="popover-content">
        {{ getDetailFirstName(activeItemElpopover?.mailCustomerOriginDetailVoList) }}
      </div>
    </template>
    <template v-else-if="popoverType === 12">
      <div class="popover-content popover-tag-list">
        <el-tag v-for="(item, index) in getRemainingDetailList(activeItemElpopover?.mailCustomerOriginDetailVoList)"
                :key="`${item.name}_${index}`"
                type="info"
                disable-transitions
                class="popover-tag-item">
          {{ formatText(item.name, sizeMaxNumber, true) }}
        </el-tag>
      </div>
    </template>
    <template v-else-if="popoverType === 7">
      <div class="popover-content">{{ activeItemElpopover.customerCode }}</div>
    </template>
    <template v-else-if="popoverType === 8">
      <div class="popover-content">{{ activeItemElpopover.createName }}</div>
    </template>
    <template v-else-if="popoverType === 9">
      <div class="popover-content">{{ activeItemElpopover.auditName }}</div>
    </template>
    <template v-else-if="popoverType === 10">
      <div class="popover-content">{{ activeItemElpopover.userName }}</div>
    </template>
    <template v-else-if="popoverType === 11">
      <div class="popover-content">
        {{ getDetailFirstName(activeItemElpopover?.mailProductDetailVoList) }}
      </div>
    </template>
    <template v-else-if="popoverType === 13">
      <div class="popover-content popover-tag-list">
        <el-tag v-for="(item, index) in getRemainingDetailList(activeItemElpopover?.mailProductDetailVoList)"
                :key="`${item.name}_${index}`"
                type="info"
                disable-transitions
                class="popover-tag-item">
          {{ formatText(item.name, sizeMaxNumber, true) }}
        </el-tag>
      </div>
    </template>
  </div>
  </el-popover>

  <!-- 抽屉 -->
  <el-drawer
      size="530px"
      v-model="isShowDrawers"
      style="padding: 15px 5px 15px 10px"
      :direction="direction"
  >
    <template #header>
      <div style="display: flex;align-items: center">
        <h4 style="color: rgba(0, 0, 0, .85);font-weight: 500;font-size: 16px;line-height: 22px;width: 410px">
          {{ activeItem.customerName }}</h4>
        <router-link
            :to="
            '/email/customer/detail/' +
            activeItem.id +
            '?tabKey=1&type=' +
            activeItem.type"
            style="color: #409eff"
        >
          <el-button v-if="isShowEdit" link type="primary">{{ $t('common.edit') }}</el-button>
        </router-link>
      </div>
    </template>
    <template #default>
      <div class="top_titles">
        <div>
          <div class="font_targert">{{ $t('common.customer.numberList') }}：{{ activeItem?.customerCode }}</div>
          <div class="font_targert" style="margin: 10px 0px;">{{ $t("common.byinput") }}：{{
              activeItem?.createName
            }}
          </div>
          <div class="font_targert" style="margin: 10px 0px;">{{
              $t("common.bybranch")
            }}：{{ activeItem.mangerVOList.map(item => item.managerName).join(',') }}
          </div>
          <div class="font_targert">
            {{ $t('sending.table.col.createTime') }}：{{ activeItem?.createTime }}
          </div>
        </div>
      </div>
      <div style="margin-top: 15px">
        <!-- table -->
        <div style="margin-top: 15px">
          <div class="customer_title">{{ $t('common.cds25') }}</div>
          <div class="small_box">
            <TableShows :key="String(activeItem?.id || '') + '_company'" :table-data="companyInfo"/>
          </div>
        </div>
        <div style="margin-top: 15px">
          <div class="customer_title">{{ $t('common.marketing.information') }}</div>
          <div class="small_box">
            <TableShows :key="String(activeItem?.id || '') + '_marketing'" :table-data="marketingInfo"/>
          </div>
        </div>
        <div style="margin-top: 15px">
          <div class="customer_title">{{ $t('common.contact') }}</div>
          <div
              class="small_box"
              v-for="(item, index) in contactInfo"
              :key="index"
          >
            <TableShows :key="String(activeItem?.id || '') + '_contact_' + index" :table-data="item"/>
          </div>
        </div>
      </div>
    </template>
  </el-drawer>
  <DeleteCustomer v-if="delVisiblePopover" v-model="delVisiblePopover" @close="closeDialog"
                  :multipleSelection="multipleSelection" :getCustomerList="refreshTable"
                  :isSelectAll="isSelectAll" :searchValue="searchValue" :type="2"></DeleteCustomer>
  <PublicLingCustomer v-if="delVisiblePopoverCustomer" v-model="delVisiblePopoverCustomer" @close="closeDialogCustomer"
                      :multipleSelection="multipleSelection" :getCustomerList="refreshTable"
                      :isSelectAll="isSelectAll" :searchValue="searchValue" @public="handleDelete"
                      :isLoadingPublicLing="isLoadingPublicLing"></PublicLingCustomer>
</template>
<script setup>
import {ref, onMounted, computed, watch, onBeforeUnmount, nextTick, reactive} from "vue";
import {useStore} from "vuex";
import {Delete, DocumentRemove, Download} from "@element-plus/icons-vue";
import {ElMessage, ElTable} from "element-plus";

import Cards from "./Cards.vue";
import TopSearch from "./TopComponents/TopSearch.vue";
import ConfirmDeletePopover from "@/components/ConfirmDeletePopover.vue";
import TableShows from "./Tables/TableShows.vue";
import {table_columns_public_list, table_columns_public_2} from './map'
import {
  getMailCustomerList,
  getMailCustomerRecord,
  addMailCustomerRecord,
  getMailCustomerRecordById, batchDeleteCustomerById,
} from "@/api/customer.js";
import {i18n} from "@/lang";
import {emptyUrl, POPOVER_DELAY_TIME, TIME_OUT} from "@/utils/statusParams";
import flag from "@/assets/flag";
import {truncateByBytes} from "../../utils/notifies/tool";
import {flexWidth, flexTagWidth} from "@/utils/tableWidth";
import {debouncePlus, isEmpty, throttle} from "@/utils/mylodash";
import DeleteCustomer from "@/components/DiaPops/DeleteCustomer.vue";
import {formatText, getColumnWidth, getTextLength, getTextWidth} from "@/utils/util";
import Pagination from "@/components/Pagination/index.vue";
import PublicLingCustomer from "@/components/DiaPops/PublicLingCustomer.vue";
import sessionStore from "@/utils/sessionStore";

const isSelectAll = ref(false);
const targetTable = ref(null);
const selectedCount = ref(10)
const direction = ref("rtl");

const topSearchRef = ref(null)

const refreshTable = async () => {
  await resetInit()
  await getCustomerList()
}

// 搜索
const searchValue = ref({});
const empty = ref(i18n.global.t('select.empty'))

const getSearchKey = async (value) => {
  // 重置选择
  const newObj = JSON.parse(JSON.stringify(value));
  if (newObj.customerOrigin === empty.value) {
    newObj.customerOrigin = ''
  }
  if (newObj.product === empty.value) {
    newObj.product = ''
  }
  if (newObj.customerTypeId === empty.value) {
    newObj.customerTypeId = ''
  }
  searchValue.value = newObj;
  // 列表数据
  await getCustomerList();
  isSelectAll.value ? targetTable.value?.toggleAllSelection() : targetTable.value?.clearSelection()
};

const store = useStore();

// 权限控制
const isSuperAdmin = computed(() => store.getters["user/isSuperAdmin"])
const isAdmin = computed(() => store.getters["user/isAdmin"])

const tableDataSelect = computed(() => {
  return isSuperAdmin.value || isAdmin.value ? [...store.state.groups.AllTableData, {
    userName: i18n.global.t('common.all'),
    userId: 'all'
  }] : store.state.groups.AllTableData;
});

const multipleTableRef = ref();
const multipleSelection = computed(() => store.state.customer.multipleSelection)
const handleSelectionChange = async (val) => {
  endIndex = val.length > 1 ? customerList.value.findIndex(item => item.id === val[val.length - 1].id) : -1;
  const startIndex = val.length > 1 ? customerList.value.findIndex(item => item.id === val[val.length - 2].id) : -1;
  console.log(endIndex, startIndex);
  if (isShiftPressed.value && val.length > 1 && endIndex !== startIndex) {
    const start = startIndex < endIndex ? startIndex : endIndex;
    const end = endIndex < startIndex ? startIndex : endIndex;
    // console.log(start, end, '===============');
    for (let i = start; i <= end; i++) {
      const row = customerList.value[i];
      if (start === i || i === end) {
        continue;
      }
      console.log(row, '更新');
      if (row) {
        targetTable.value.toggleRowSelection(row, true); // 调用表格组件的方法来更新选中状态
      }
    }
    nextTick(async () => {
      await store.commit("customer/setMultipleSelection", targetTable.value.getSelectionRows())
    });
  } else {
    console.log(val, '=====')
    await store.commit("customer/setMultipleSelection", val)
  }
};

const tableData = ref([{}]);
const dialogVisible = ref(false);
const selectKeys = ref();

// 分页
const currentPublic = ref(1);
const sizePublic = ref(10);
const totalsPublic = ref(0);
const isLoading = ref(false);

const delVisiblePopover = ref(false);

// 全部公海客户列表数据
const customerList = ref([]);
const teamId = computed(() => store.state.email.teamID);
const getCustomerList = async () => {
  isLoading.value = true;
  if (searchValue.value.managerId === "all") {
    searchValue.value.managerId = ""
  }
  let res = await getMailCustomerList({
    ...searchValue.value,
    pageSize: sizePublic.value,
    pageNo: currentPublic.value,
    teamId: teamId.value,
    type: 2,
  })
  if (res.code !== 200) {
    ElMessage.error(res.message);
    return
  }
  isLoading.value = false;
  const {records, size, total, current} = res.result;
  customerList.value = records;
  totalsPublic.value = total;
  sizePublic.value = size;
  currentPublic.value = res.result.current;
};

const handleCurrentChange = async (page) => {
  const {pageNo, pageSize} = page
  currentPublic.value = pageNo;
  sizePublic.value = pageSize;
  //  重新获取数据
  await getCustomerList();
  // 全选
  if (isSelectAll.value) {
    await getSelectValue()
  }
}

const handleSizeChange = async (pageSize) => {
  sizePublic.value = pageSize;
  await getCustomerList();
}

const currentDia = ref(1);
const sizeDia = ref(10);
const totalsDia = ref(0);
const isLoadingDia = ref(false);

// 领用记录
const userInfo = computed(() => store.state.user.userInfo)
const handleClickRecent = async () => {
  console.log(userInfo.value, 'userInfo.value')
  dialogVisible.value = true;
  isLoadingDia.value = true;
  selectKeys.value !== 'all' ? selectKeys.value = userInfo.value.id : selectKeys.value = "all";
  await getFollowList()
};

const handleCurrentChangeDia = (page) => {
  console.log(page, selectKeys.value);
  currentDia.value = page;

  handleClickRecent();
};

// const handleSizeChangeDia = (pageSize) => {
//   sizeDia.value = pageSize;
//   handleClickRecent();
// }

// 确认框
const dialogVisiblePopover = ref(false);
const handleClickExport = () => {
  if (multipleSelection.value.length === 0) {
    ElMessage.warning(i18n.global.t('common.email.chooseCustomer'));
    return;
  }
  delVisiblePopoverCustomer.value = true;
};

const isLoadingPublicLing = ref(false)
const handleDelete = async (row, column, $index) => {
  // 领用
  const result = multipleSelection.value.map((item) => ({
    customerId: item.id, customerName: item.customerName
  }));
  let targetObj = null;
  if (multipleSelection.value.length >= 1) {
    // 批量领用
    targetObj = {
      ...searchValue.value,
      customerDTOList: result,
      teamId: teamId.value,
      selectAll: isSelectAll.value
    };
    isLoadingPublicLing.value = true
    let res = await addMailCustomerRecord(targetObj);
    if (res.code !== 200) {
      isLoadingPublicLing.value = false
      ElMessage.error(res.message);
      return;
    }
    isLoadingPublicLing.value = false
    delVisiblePopoverCustomer.value = false
    ElMessage.success(res.message);
    // 章徽
    // store.commit('customer/setApprovalBadge', targetObj.customerDTOList.length)
    await store.dispatch('countshow/getTeamAllDataApis')
    await getCustomerList();
    await resetInit()
  }
};

const handleDeleteRow = async (row, column, $index) => {
  let targetObj = null;
  if (multipleSelection.value.length === 0) {
    // 行内领用
    targetObj = {
      customerDTOList: [{customerId: row.id, customerName: row.customerName}],
      teamId: teamId.value,
    };
    let res = await addMailCustomerRecord(targetObj);
    if (res.code !== 200) {
      ElMessage.error(res.message);
      return;
    }
    ElMessage.success(res.message);
    // 章徽
    // store.commit('customer/setApprovalBadge', targetObj.customerDTOList.length)
    await store.dispatch('countshow/getTeamAllDataApis')
    await getCustomerList();
    await resetInit()
  } else {
    ElMessage.warning(i18n.global.t('please.batch.accept'))
  }
}


const closeDialog = () => {
  console.log('关闭', targetTable.value);
  targetTable.value.clearSelection();
  delVisiblePopover.value = false;
}

// const handleSelectionChangeCustomerList = (data) => {
//
// };
// 选择领用人 select
const loading = ref(false);
const clickSelection = async (value) => {
  selectKeys.value = value;
  console.log(selectKeys.value, "selectKeys");
  await getFollowList()
};

const getFollowList = async () => {
  try {
    loading.value = true
    let res = await getMailCustomerRecord({
      userId: selectKeys.value === "all" ? null : selectKeys.value,
      pageSize: sizeDia.value,
      pageNo: currentDia.value,
      teamId: teamId.value,
    });
    if (res.code !== 200) {
      ElMessage.error(res.message);
      return;
    }
    loading.value = false
    const {records, size, total} = res.result;
    tableData.value = records;
    currentDia.value = res.result.current;
    sizeDia.value = size;
    totalsDia.value = total
  } catch (e) {
    loading.value = false
  }
}
const PageZQ = ref()
// 重置记录
const resetInit = async () => {
  try {
    await topSearchRef.value?.getSelectTarget()
    // parent
    isSelectAll.value = false
    // child
    await PageZQ.value.setIsSelectAll(isSelectAll.value)
    // 清空选项
    await store.commit("customer/setGlobalSelectedRows", []);
    await store.commit("customer/setSelectedRows", []);
    await store.commit("customer/setMultipleSelection", [])
    await nextTick()
    targetTable.value?.clearSelection()
  } catch (e) {

  }
}

// 删除按钮
const handleClickDelete = throttle(() => {
  console.log(multipleSelection.value);
  if (multipleSelection.value.length === 0) {
    ElMessage.warning(i18n.global.t('common.email.chooseCustomer'));
    return;
  }
  delVisiblePopover.value = true;
}, 2000)

// table 中的 confirm
const requestHandleDelete = (row) => {
  row.popoverVisible = true;
};
const cancelPopover = (row) => {
  console.log(row, "row");
  row.popoverVisible = false;
};
// 抽屉的展示
const isShowDrawers = ref(false);
// 公司信息
const companyInfo = ref([]);
// 营销信息
const marketingInfo = ref([]);
// 联系人信息
const ruleFormCustomer = computed(() => store.state.customer.ruleForm);
const contactList = computed(() => store.state.customer.contactList);
// 联系人
const contactInfo = ref([]);
// 选中的行
const activeItem = computed(() => store.state.customer.ruleForm)
// 档案信息
const handleClickTargetData = async (item) => {
  isShowDrawers.value = true;
  sessionStore.set('customerId', item.id)
  await store.dispatch("customer/getQueryById", {
    customerId: item.id,
  });
  if (ruleFormCustomer.value) {
    const {
      customerName,
      phoneWayList,
      setUpTime,
      economicNature,
      companyWebsite,
      companyAddress,
      companyFax,
      emailWayList,
      customerOriginList,
      zoneAddress,
      companyRemark,
      // ----
      customerType,
      customerLevel,
      product,
      productList,
      marketingRemark,
      mailLabelVoList,
    } = ruleFormCustomer.value;
    console.log(ruleFormCustomer.value, "fff");

    companyInfo.value = [
      {
        name: i18n.global.t("common.region.name"),
        value: zoneAddress,
      },
      {
        name: i18n.global.t("common.customer.source"),
        value: item?.mailCustomerOriginDetailVoList?.filter(item => item.name !== '').length > 0 ? item?.mailCustomerOriginDetailVoList?.filter(item => item.name !== '') : '',
      },
      {
        name: i18n.global.t('common.establishment'), value: setUpTime
      },
      {
        name: i18n.global.t('common.economicnature'), value: economicNature
      },
      {
        name: i18n.global.t('common.cds6'),
        value:
            emailWayList.length !== 0 ? emailWayList.filter((item) => item.isDefault === 1)[0]?.content :
                [],
      },
      {
        name: i18n.global.t('common.cds2'), value: companyAddress
      },
      {
        name: i18n.global.t("more.check.phone"),
        value: phoneWayList.length !== 0 ? phoneWayList.filter((item) => item.isDefault === 1)[0]?.content :
            [],
      },
      {
        name: i18n.global.t('common.faxnumber'), value:
        companyFax
      },
      {
        name: i18n.global.t('common.company.website'), value:
        companyWebsite
      },
      {
        name: i18n.global.t('other.remark'), value:
        companyRemark
      },
    ];
    marketingInfo.value = [
      {name: i18n.global.t('common.customer.typeList'), value: customerType},
      {name: i18n.global.t('common_customer_level'), value: customerLevel},
      {
        name: i18n.global.t('common.interest.product'),
        value: item?.mailProductDetailVoList?.filter(item => item.name !== '').length > 0 ? item?.mailProductDetailVoList?.filter(item => item.name !== '') : ''
      },
      {name: i18n.global.t('create.customer.des'), value: marketingRemark},
    ];
    // 联系人详情
    await store.commit("customer/setContactPage", {
      page: 1,
      pageSize: 999,
    });
    await store.dispatch("customer/getContactList");
    // 清除数据干扰
    contactInfo.value = [];
    // 联系人详情
    contactInfo.value = contactList.value.map((item) => [
      {name: i18n.global.t('common.name'), value: item.name},
      {name: i18n.global.t('common.email'), value: item.email},
      {name: 'WhatsApp', value: item.whatsAppPhone},
    ]);
  }
};

watch(() => teamId.value, async () => {
  await getCustomerList();
  await store.dispatch("groups/getUserList", {teamId: teamId.value});
})

// 获取数据
onMounted(async () => {
  // Shift监听/取消监听
  document.addEventListener('keydown', handleKeyDown);
  document.addEventListener('keyup', handleKeyUp);
  await store.dispatch("groups/getUserList", {teamId: teamId.value});
});

onBeforeUnmount(() => {
  document.removeEventListener('keydown', handleKeyDown);
  document.removeEventListener('keyup', handleKeyUp);
});

const rowClassName = ({row, column, rowIndex, columnIndex}) => {
  console.log(row, columnIndex)
  if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2) {
    return {textAlign: 'left'}
  } else {
    return {textAlign: 'center'}
  }
}
const rowClassNamePublic = ({row, column, rowIndex, columnIndex}) => {
  if (columnIndex === 1 || columnIndex === 2 || columnIndex === 4 || columnIndex === 5) {
    return {textAlign: 'left'}
  } else {
    return {textAlign: 'center'}
  }
}

const headerClassName = ({row, column, rowIndex, columnIndex}) => {
  if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2) {
    return {'text-align': 'left', background: '#f9f9f9', color: 'black', padding: '8px 0px'}
  } else {
    return {'text-align': 'center', background: '#f9f9f9', color: 'black', padding: '8px 0px'}
  }
}
const headerClassNamePublic = ({row, column, rowIndex, columnIndex}) => {
  if (columnIndex === 1 || columnIndex === 2 || columnIndex === 4 || columnIndex === 5) {
    return {'text-align': 'left', background: '#f9f9f9', color: 'black', padding: '8px 0px'}
  } else {
    return {'text-align': 'center', background: '#f9f9f9', color: 'black', padding: '8px 0px'}
  }
}

const handleDeleteRowCustomer = throttle(async (row) => {
  const params = {
    customerIdList: [row.id],
    teamId: teamId.value,
    customerOrigin: searchValue.value.customerOrigin,
    customerTypeId: searchValue.value.customerTypeId,
    customerName: searchValue.value.customerName,
    customerCode: searchValue.value.customerCode,
    email: searchValue.value.email,
    type: 2,
    zoneAddress: searchValue.value.zoneAddress,
  }
  try {
    await batchDeleteCustomerById(params)
    ElMessage.success(i18n.global.t('delete.all.batch.success'))
    await getCustomerList()
    await resetInit()
  } catch (e) {
    ElMessage.error(e.message)
  }
}, TIME_OUT)


let endIndex = -1;
// table 选择增加 shift
const isShiftPressed = ref(false); // 标记 Shift 键是否被按下
const handleKeyDown = (event) => {
  if (event.key === 'Shift' && event.keyCode === 16) {
    // console.log("进来了-----------------", event.key, event.keyCode);
    isShiftPressed.value = true;
  }
};

const handleKeyUp = (event) => {
  if (event.key === 'Shift' && event.keyCode === 16) {
    isShiftPressed.value = false;
  }
};


// el-popover 优化
const refMap = ref({})
const tempRef = ref()
const visiblePopover = ref(false)
// popover 过渡动画：正常显隐保留渐隐渐显，切换触发元素时临时置为 none，保证新 popover 以最终状态直接呈现
const popoverTransition = ref('el-fade-in-linear')
// 隐藏 popover 的定时器，展示前需取消，避免闪动
let popoverHideTimer = null
// -1-字句审核 0-整句审核 1-日志查看
const popoverType = ref(0)
const activeItemElpopover = ref(null)

const handleRef = debouncePlus((ref, item, type) => {
  if (popoverHideTimer) {
    clearTimeout(popoverHideTimer)
    popoverHideTimer = null
  }
  // popover 已显示时切换触发元素，先隐藏再展示，避免新内容在旧位置渲染一帧造成闪动
  if (visiblePopover.value && tempRef.value !== ref) {
    // 切换期间临时禁用过渡动画，避免离场动画暴露内容与位置的变化过程
    popoverTransition.value = 'none'
    visiblePopover.value = false
    nextTick(() => {
      tempRef.value = ref
      popoverType.value = type
      activeItemElpopover.value = item
      visiblePopover.value = true
      // 切换呈现完成后恢复渐隐渐显动画
      nextTick(() => {
        popoverTransition.value = 'el-fade-in-linear'
      })
    })
    return
  }
  tempRef.value = ref
  popoverType.value = type
  activeItemElpopover.value = item;
  if (type === 1) {
    // ...业务逻辑1
  } else {
    // ...业务逻辑2、3
  }
  visiblePopover.value = true
}, POPOVER_DELAY_TIME)


const checkAllItemPage = () => {
  targetTable.value.clearSelection()
  isSelectAll.value = true
}
const unCheckAllItemPage = () => {
  targetTable.value.clearSelection()
  isSelectAll.value = false
}
const getSelectValue = async (val) => {
  if (val !== undefined) {
    isSelectAll.value = val
  }
  await nextTick(() => {
    customerList.value.forEach((item) => {
      targetTable?.value.toggleRowSelection(item, isSelectAll.value)
    })
  })
}

const handleCheck = async (value) => {
  if (isSelectAll.value) {
    isSelectAll.value = false;
  }
  await getSelectChange(value)
}

const getSelectChange = async (val) => {
  console.log(val, '当前页勾选的值');
  // 选择 底部选择 取消 全部勾选
  await nextTick(async () => {
    // 获取当前页的页码，假设分页数据存储在 store 中
    const currentPage = currentPublic.value;

    // 获取全局勾选记录
    const globalSelectedRows = store.state.customer.globalSelectedRows || {};

    // 更新当前页的勾选数据到全局记录
    globalSelectedRows[currentPage] = val;

    // 提交更新全局勾选记录到 store
    await store.commit("customer/setGlobalSelectedRows", globalSelectedRows);

    // 合并所有页的勾选数据
    const allSelectedRows = Object.values(globalSelectedRows).flat();

    // 更新 `selectedRows` 和 `targetEmailList`
    await store.commit("customer/setSelectedRows", allSelectedRows);
  })
}

const handleClickSelectAll = async (val) => {
  console.log(val, '当前页勾选的值');
  // 获取当前页的页码，假设分页数据存储在 store 中
  const currentPage = currentPublic.value;

  // 获取全局勾选记录
  const globalSelectedRows = store.state.customer.globalSelectedRows || {};

  // 更新当前页的勾选数据到全局记录
  globalSelectedRows[currentPage] = val;

  // 提交更新全局勾选记录到 store
  await store.commit("customer/setGlobalSelectedRows", globalSelectedRows);

  // 合并所有页的勾选数据
  const allSelectedRows = Object.values(globalSelectedRows).flat();

  // 更新 `selectedRows` 和 `targetEmailList`
  await store.commit("customer/setSelectedRows", allSelectedRows);
}

const selectedRows = computed(() => store.state.customer.selectedRows)
const globalSelectedRows = computed(() => store.state.customer.globalSelectedRows)
const isCounterElection = computed(() => store.state.customer.isCounterElection);
// 记录历史记录
const resetSelection = async () => {
  await nextTick(() => {
    console.log(targetTable?.value, customerList.value, selectedRows.value, 'treeTable?.value')
    if (targetTable?.value && selectedRows?.value.count > 0) {
      customerList.value.forEach((item) => {
        const isSelected = selectedRows.value?.some((selected) => selected.id === item.id);
        console.log(item, isSelected, selectedRows.value.map(item => item.id), 'isSelected')
        targetTable?.value.toggleRowSelection(item, isSelected);
      })
    }
  })
}

// 当前页数据发生变化
watch(() => customerList.value, (newValue) => {
  if (newValue) {
    console.log('newValue')
    resetSelection()
  }
}, {immediate: true})

const delVisiblePopoverCustomer = ref(false)
const closeDialogCustomer = () => {
  delVisiblePopoverCustomer.value = false
}

const clearVisiblePopover = () => {
  // 取消尚未执行的展示任务，并复用同一个隐藏定时器，避免旧定时器误关新 popover
  handleRef.cancel()
  if (popoverHideTimer) clearTimeout(popoverHideTimer)
  popoverHideTimer = setTimeout(() => {
    visiblePopover.value = false
    popoverHideTimer = null
  }, POPOVER_DELAY_TIME + 10)
}

// 鼠标移入 popover 内容时保持显示，避免 popover 覆盖触发元素时反复显隐跳动
const keepPopoverVisible = () => {
  handleRef.cancel()
  if (popoverHideTimer) {
    clearTimeout(popoverHideTimer)
    popoverHideTimer = null
  }
}

const toDetail = (row) => {
  const newUrl = router.resolve('/email/customer/detail/' + row.id + '?type=' + row.type)
  openNewWindow(newUrl.href);
}
const openNewWindow = (url) => {
  window.open(url, "_blank");
};


const lang = computed(() => store.state.system.langLocal)
const middleValueWidth = ref(165)
// 字数大致限制
const sizeMaxNumber = ref(16)
const getDetailList = (list = []) => {
  if (!Array.isArray(list)) {
    return []
  }

  return list.filter(item => item?.name !== '')
}

// 标签计算结果缓存：以源数组为键，避免每次渲染都 filter/slice 生成新数组，导致 popover 内标签列表被重建而闪动
const EMPTY_DETAIL_INFO = {firstName: '', extraCount: 0, remainingList: []}
const detailInfoCache = new WeakMap()
const getDetailInfo = (list) => {
  if (!Array.isArray(list)) {
    return EMPTY_DETAIL_INFO
  }
  let info = detailInfoCache.get(list)
  if (!info || info.sourceLength !== list.length) {
    const validList = getDetailList(list)
    info = {
      sourceLength: list.length,
      firstName: validList[0]?.name || '',
      extraCount: Math.max(validList.length - 1, 0),
      remainingList: validList.slice(1)
    }
    detailInfoCache.set(list, info)
  }
  return info
}

const getDetailFirstName = (list = []) => {
  return getDetailInfo(list).firstName
}

const getDetailExtraCount = (list = []) => {
  return getDetailInfo(list).extraCount
}

const getRemainingDetailList = (list = []) => {
  return getDetailInfo(list).remainingList
}

const shouldShowTagNamePopover = (list = []) => {
  return getTextLength(getDetailFirstName(list)) > sizeMaxNumber.value
}

// 按“实际展示内容”(截断后的首标签 + 是否有 +N 按钮)计算标签列宽
const getTagColWidth = (listField, title) => {
  const rows = customerList.value
  const items = Array.isArray(rows) ? rows.map((row) => {
    const list = row?.[listField]
    const name = getDetailFirstName(list)
    return {
      text: shouldShowTagNamePopover(list) ? formatText(name, sizeMaxNumber.value, true) : name,
      hasExtra: getDetailExtraCount(list) > 0
    }
  }) : []
  return flexTagWidth(items, title)
}

const handleClickSelectWidth = (item, type) => {
  if (item.value === "customerCode") {
    return flexWidth('customerCode', customerList.value, i18n.global.t('common_customer_number')) > middleValueWidth.value ? middleValueWidth.value : flexWidth('customerCode', customerList.value, i18n.global.t('common_customer_number')) + 20
  } else if (item.value === "customerType") {
    return flexWidth('customerType', customerList.value, i18n.global.t('common_customer_type')) > middleValueWidth.value ? middleValueWidth.value : flexWidth('customerType', customerList.value, i18n.global.t('common_customer_type')) + 20
  } else if (item.value === 'customerOrigin') {
    return getTagColWidth('mailCustomerOriginDetailVoList', i18n.global.t('common.customer.source'))
  } else if (item.value === 'customerIntention') {
    return getTagColWidth('mailProductDetailVoList', i18n.global.t('common.interest.product'))
  } else if (item.value === 'createName') {
    if (flexWidth('createName', customerList.value, i18n.global.t('common.byinput')) > middleValueWidth.value) {
      return middleValueWidth.value
    } else {
      if (flexWidth('createName', customerList.value, i18n.global.t('common.byinput')) < 80) {
        return 80
      } else {
        return flexWidth('createName', customerList.value, i18n.global.t('common.byinput'))
      }
    }
  } else if (item.value === 'auditName') {
    if (type === 1) {
      return 80
    } else if (type === 2) {
      return flexWidth('auditName', tableData.value, i18n.global.t('common.shr')) > middleValueWidth.value ? middleValueWidth.value : flexWidth('auditName', customerList.value, i18n.global.t('common.shr'))
    }
  } else if (item.value === 'userName') {
    if (type === 1) {
      return 80
    } else if (type === 2) {
      return flexWidth('userName', tableData.value, i18n.global.t('common.claim.user')) > middleValueWidth.value ? middleValueWidth.value : flexWidth('userName', customerList.value, i18n.global.t('common.claim.user'))
    }
  } else if (item.value === 'customerLevel') {
    return lang.value !== 'zh-CN' ? 120 : 80;
  } else if (item.value === 'maiContactVOList' || item.value === 'zoneAddress') {
    return 80;
  } else if (item.value === 'lastTime' || item.value === 'applyTime' || item.value === 'followTime') {
    return 150;
  } else if (item.value === 'setting' || item.value === 'auditStatus') {
    return 120;
  } else if (item.value === 'mangerVOList') {
    return 120;
  } else {
    return "auto"
  }
}

const handleClickSelectMinWidth = (item, type) => {
  if (type === 1) {
    if (item.value === "customerName") {
      return 120;
    } else if (item.value === "customerOrigin") {
      return 140;
    } else if (item.value === "customerLevel") {
      return 120;
    } else if (item.value === 'mangerVOList') {
      return 120;
    } else {
      return 120;
    }
  }
}

const overflowMap = reactive({})

const setRef = (el, row) => {
  if (!el) return
  refMap[row.id] = el

  nextTick(() => {
    overflowMap[row.id] = Math.ceil(el.scrollWidth) >= Math.ceil(el.clientWidth)
  })
}

const handleMouseEnter = (row) => {
  if (overflowMap[row.id]) {
    handleRef(refMap[row.id], row, 5)
  }
}

</script>

<style scoped lang="less">
@import "../../less/page.less";

.table_name {
  font-size: 20px;
}

.top_tips {
  display: flex;
  justify-content: space-between;
}

.pages {
  //margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.settings {
  display: flex;
  justify-content: center;
}

:deep(.el-table__cell) {
  text-align: center;
}

.inners {
  display: flex;
  justify-content: center;
  align-items: center;

  & > .el-icon {
    color: #faad14;
    margin-right: 2px;
  }
}

:deep(.el-empty__image img) {
  width: 54% !important;
}

:deep(.el-empty__description) {
  margin-top: -20px;
}

:deep(.el-table__header) {
  width: 100% !important;
}

:deep(.el-table__body) {
  width: 100% !important;
}

.pages :deep(.el-pagination .el-select) {
  width: 100px !important;
}

.text_long {
  overflow: hidden; //超出的文本隐藏
  text-overflow: ellipsis; //溢出用省略号显示
  white-space: nowrap; //溢出不换行
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
}

:deep(.el-table_1_column_4) {
  .el-tooltip {
    margin: auto !important;
  }
}

:deep(.el-table .cell) {
  font-size: 13px !important;
  font-weight: normal !important;
}

:deep(.el-form-item__label) {
  font-weight: normal !important;
  font-size: 13px !important;
}

.customer_title {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 15px;
}

.top_titles {
  padding-bottom: 15px;
  border-bottom: 1px solid #ebebeb;
}

.popover-content {
  max-width: 300px;
  max-height: 200px;
  overflow-y: auto;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: break-word;
  padding-right: 4px; /* 给滚动条留点空间 */
}

.tag-popover-trigger {
  margin-left: 4px;
  padding: 0;
  height: auto;
}

.popover-tag-list {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.popover-tag-item {
  margin-bottom: 8px;
}

.popover-tag-item:last-child {
  margin-bottom: 0;
}

.font_targert {
  font-size: 14px;
  color: black;
}
</style>
